export const LIST_NAME_METRICS = 'LIST_NAME_METRICS'
export const LIST_NAME_METRICS_RESET = 'LIST_NAME_METRICS_RESET'

export interface ListMetricsState {
  list_name: string | null
}

export interface ListMetricsReset {
  type: typeof LIST_NAME_METRICS_RESET
  payload: null
}

export const InitialState: ListMetricsState = {
  list_name: null,
}

export interface ListNameMetric {
  type: typeof LIST_NAME_METRICS
  payload: string
}

export type ListNameMetricActions = ListNameMetric | ListMetricsReset
